import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../stores/types/types';
import { ROOM_STATES } from '../../stores/reducers/settings';
import { DRAG_TYPE } from '../../stores/reducers/user-interface';

interface Props {
    isForShotEditorModal: Boolean;
}

export default function GreenBox(props: Props) {
	const { isForShotEditorModal } = props;
	const {
		graphics,
		shotModalGraphics = [],
	} = useSelector((state: GreenroomState) => state.GraphicsReducer);
	const { typeOfDragging, idOfDragging } = useSelector((state: GreenroomState) => state.UserInterfaceReducer);

	const roomState = useSelector((state: GreenroomState) => state.MeetingReducer.roomState);
	const shots = useSelector((state: GreenroomState) => state.ShotsReducer.shots);

	const currentGraphic = useMemo(() => {
		if (typeOfDragging === DRAG_TYPE.OVERLAY) {
			return isForShotEditorModal
				? shotModalGraphics?.find(g => g.id === idOfDragging) || graphics?.find(g => g.id === Number(idOfDragging))
				: graphics?.find(g => g.id === Number(idOfDragging));
		}
	}, [typeOfDragging, idOfDragging]);

	const isInAShot = useMemo(() => {
		if (currentGraphic) {
			for(let i = 0; i < shots.length; i += 1) {
				const shot = shots[i];
				if (shot?.shot_data?.shotGraphics?.includes(Number(currentGraphic.id))) {
					return true;
				}
			}
		}
		return false;
	}, [currentGraphic, shots]);

	const style = useMemo(() => {
		if (!currentGraphic) return { display: 'none' };
		return {
			top: currentGraphic.pos_y + '%',
			left: currentGraphic.pos_x + '%',
			width: currentGraphic.scale_x + '%',
			height: currentGraphic.scale_y + '%',
			transform: `rotate(${currentGraphic.rotate}deg)`,
			display: typeOfDragging === DRAG_TYPE.OVERLAY && currentGraphic && isInAShot && (roomState === ROOM_STATES.EDITING || isForShotEditorModal)
				? 'flex'
				: 'none',
		};
	}, [currentGraphic, typeOfDragging, isInAShot, roomState, isForShotEditorModal]);

	// TODO: animated border code below
	// return (
	// 	<>
	// 		<div className="green-box-border" style={style}>
	// 			&nbsp;
	// 		</div>
	// 		<div className="green-box" style={style}>
	// 			&nbsp;
	// 		</div>
	// 	</>
	// );

	return (
		<div className="green-box" style={style}>
			&nbsp;
		</div>
	);
}
